import { render, staticRenderFns } from "./AdditionalDocumentsActivity.vue?vue&type=template&id=c8ccaffa&scoped=true&"
import script from "./AdditionalDocumentsActivity.vue?vue&type=script&lang=js&"
export * from "./AdditionalDocumentsActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=c8ccaffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ccaffa",
  null
  
)

export default component.exports